/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import React, { Component } from 'react'
import { Form, Search, Popup, Icon } from 'semantic-ui-react'
import _ from 'lodash'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css'
import { getFirmList } from '../api/getEntrySummaryData'

// import Images from '../../config/images';
const resultRenderer = ({ description, ediid }) => (
  <div>{ediid.concat(' - ', description)}</div>
)
export class SearchFirmList extends Component {
  constructor() {
    super()
    this.state = {
      results: [],
      isLoading: false
    }
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.handleResultSelect = this.handleResultSelect.bind(this)
    this.getFirmListAPI = _.debounce(this.getFirmListAPI.bind(this), 500, {
      leading: true,
      trailing: true
    })
  }

  handleResultSelect = (e, { result }) => {
    this.props.onChange(result.ediid)
    // Need to save functions, 1 for item selection (this one) 2nd in onBLur if its typed out
    this.props.onBlur(result.ediid)
  }

  getFirmListAPI(value, USportOfUnladingCode) {
    this.setState({
      isLoading: true
    })
    if (value?.length > 2) {
      getFirmList(value, USportOfUnladingCode, this.props.country)
        .then(response => {
          try {
            let firmList = response.data.eventMessage.terminalList.map(
              (entity, index) => {
                let description = entity.terminalName
                let ediid = entity.firmCode
                return {
                  key: index,
                  description: description,
                  terminalAddress: entity.terminalAddress,
                  terminalName: entity.terminalName,
                  ediid: ediid,
                  title: ediid
                }
              }
            )
            this.setState({
              results: firmList,
              isLoading: false
            })
          } catch (e) {
            console.log('catch error')
            return this.setState({
              results: [],
              isLoading: false
            })
          }
        })
        .catch(err => {
          console.log('GET_FIRM_LIST ERROR', err)
        })
    }
  }

  handleSearchChange = (value, USportOfUnladingCode) => {
    if (value?.length <= 0) {
      return this.setState({
        results: [],
        isLoading: false
      })
    } else return this.getFirmListAPI(value, USportOfUnladingCode)
  }

  errorPopup = errors => {
    const error = errors.map((info, index) => {
      return (
        <div className='error' key={index}>
            * {info}
        </div>
      )
    })
    return (
      <Popup trigger={<Icon name='warning sign' color='red' />} content={error || ''} />
    )
  }
  render() {
    const {
      id,
      dateClass,
      label,
      width,
      isLabel,
      type,
      onChange,
      disabled,
      value,
      labelClassName,
      USportOfUnladingCode,
      onBlur,
      noResultsMessage,
      className,
      errors
    } = this.props
    let seen = [];
    window.GLOBAL_ALL_FIRMS_LIST = window.GLOBAL_ALL_FIRMS_LIST || [];
    for(let onefirm of window.GLOBAL_ALL_FIRMS_LIST){
      seen.push(onefirm.ediid);
    }
    for(let onefirm of this.state.results){
      if(seen.includes(onefirm.ediid))continue;
      seen.push(onefirm.ediid);
      window.GLOBAL_ALL_FIRMS_LIST.push(onefirm);

    }
    return (
      <React.Fragment>
        {type !== 'date' && (
          <label
            htmlFor='floatField'
            className={
              labelClassName
                ? 'name-label es ' + labelClassName
                : 'name-label es'
            }
          >
            { (errors && errors.length) ? this.errorPopup(errors) : ''}
            {label}
          </label>
        )}
        <Form.Field className={dateClass} width={width}>
          {isLabel && <label size='small'> {label} </label>}
          <Search
            scrolling='true'
            className={className}
            onResultSelect={this.handleResultSelect}
            resultRenderer={resultRenderer}
            loading={this.state.isLoading}
            results={this.state.results}
            name={id}
            id={id + window.shipmentId}
            onBlur={e => {
              if(this.state.isLoading && e.target.value)return;
              onBlur(e.target.value)
            }}
            onMouseDown={e => {
              e.stopPropagation()
              this.handleSearchChange(value, USportOfUnladingCode)
            }}
            fluid
            value={value}
            onSearchChange={event => {
              onChange(event.target.value)
              this.handleSearchChange(event.target.value, USportOfUnladingCode)
            }}
            disabled={disabled}
            noResultsMessage={noResultsMessage}
          />
        </Form.Field>
      </React.Fragment>
    )
  }
}

export default SearchFirmList
